import * as React from 'react';
import Pagination from 'react-bootstrap/Pagination';

// import "./Pagination.scss";

interface PaginationProps {
  resultsCount: number;
  size: number;
  from: number;
  handlePageChange: (from: number, size: number) => void;
}

const PaginationComponent = ({ resultsCount, size, from, handlePageChange }: PaginationProps) => {
  const pageNumbers: any[] = [];
  const pagePerSection = 10;
  const totalPages = Math.ceil(resultsCount / size);
  const totalSections = totalPages / pagePerSection;
  const currentPage = Math.floor(from / size);
  const currentSection = Math.floor(currentPage / pagePerSection);
  const currentSectionBottom = currentSection * pagePerSection;
  const currentSectionTop = currentSection * pagePerSection + pagePerSection;

  pageNumbers.push(
    <Pagination.First
      disabled={currentPage === 0}
      onClick={() => {
        handlePageChange(0, size);
      }}
      key={'pagination-first'}
    />
  );

  pageNumbers.push(
    <Pagination.Prev
      disabled={currentPage === 0}
      onClick={() => {
        handlePageChange(from - size, size);
      }}
      key={'pagination-prev'}
    />
  );

  /* Page selector for one page lower than lower bound of current section.
  Disabled if the page is lower than page per section, meaning we're in
  the first section */
  const pageOneLower = currentSectionBottom - 1;
  pageNumbers.push(
    <Pagination.Ellipsis
      disabled={currentPage <= pagePerSection}
      onClick={() => {
        handlePageChange(pageOneLower * size, size);
      }}
      key={'pagination-prev-section'}
    />
  );

  for (let i = currentSectionBottom; i < currentSectionTop; i += 1) {
    if (i < totalPages) {
      pageNumbers.push(
        <Pagination.Item
          active={currentPage === i}
          onClick={() => {
            handlePageChange(i * size, size);
          }}
          key={`pagination-${i}`}
        >
          {i + 1}
        </Pagination.Item>
      );
    }
  }

  /* Page selector for one page higher than upper bound of current section.
  Disabled if the current section is greater than or equal to the total
  sections, meaning we're in the last section */
  const pageOneHigher = currentSectionTop;
  pageNumbers.push(
    <Pagination.Ellipsis
      disabled={currentSection >= totalSections - 1}
      onClick={() => {
        handlePageChange(pageOneHigher * size, size);
      }}
      key={'pagination-next-section'}
    />
  );

  pageNumbers.push(
    <Pagination.Next
      disabled={currentPage === totalPages - 1 || from + size > 10000}
      onClick={() => {
        handlePageChange(from + size, size);
      }}
      key={'pagination-next'}
    />
  );

  pageNumbers.push(
    <Pagination.Last
      disabled={currentPage === totalPages - 1 || resultsCount > 10000}
      onClick={() => {
        handlePageChange(totalPages * size - size, size);
      }}
      key={'pagination-last'}
    />
  );

  return <>{resultsCount > 0 && <Pagination>{pageNumbers.map(el => el)}</Pagination>}</>;
};

export default PaginationComponent;
